import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import axios from '../../API/axios';
import img from '../../assets/images/khojgraphics/Moving_graphic_2.gif'


Box07.propTypes = {};



function Box07(props) {

	const profilPic = localStorage.getItem("profilPic");


	return (
		<section className="review-job-section-four">
			<Tabs className="tf-tab">
				<div className="container">
					<div className="row aln-center-mb tf-title mt-4">
						<div className="col-lg-7 content-tab wow fadeInRight">
							<h1 className="f-600 mb-3">The Journey of <span className="khoj-text-color">KHOJ</span>: From Idea to Reality</h1>
							{/* <h5 className="f-600 mb-3"></h5> */}
							<p >Every impactful creation begins with a question that challenges the status quo. For People Labs, that question was simple yet profound:
							<span className="fst-italic"> How can talent meet opportunity in a world brimming with potential but riddled with barriers?</span> </p>
							<p>Since its inception in 2010, People Labs, being architects of transformation, has touched over 65,000 lives, collaborated with 150+ organizations, and engaged with more than 500 academic institutions through training, consulting, and recruitment. But these numbers are more than just milestones—they’re stories of inspiration, innovation, and connection.
							</p>
							<p>As People Labs worked closely with industries, academic institutions, and students, it became clear that solving the disconnect between talent and opportunity required more than isolated efforts. To address this, People Labs adopted the nodal campus concept—a centralized establishment uniting academia, industry, and research under one roof. This unique approach fostered alliances, accelerated innovation, and equipped individuals with not just skills but mastery. It became a space where stakeholders could come together to solve real-world challenges and shape the future of work collaboratively.</p>
                            <p>But even with these efforts, one gap remained—a need for a unified platform that could simplify transitions and amplify opportunities. 
							</p>
						 </div>


						<div className="col-lg-5 text-center">
							<img
								src={img}
								alt="images"
								width={'90%'}
							/>
						</div>
					</div>
				</div>
			</Tabs>
		</section>
	);
}

export default Box07;
